// @flow
import type { Action, Client, GetState } from 'state/types';
import {
  CREATE_CERT_REQUEST,
  CREATE_CERT_REQUEST_FAIL,
  CREATE_CERT_REQUEST_SUCCESS,
  DELETE_CERT_REQUEST,
  DELETE_CERT_REQUEST_FAIL,
  DELETE_CERT_REQUEST_SUCCESS,
  GET_CERT_STATUS,
  GET_CERT_STATUS_FAIL,
  GET_CERT_STATUS_SUCCESS,
  IMPORT_CERT,
  IMPORT_CERT_FAIL,
  IMPORT_CERT_SUCCESS,
  type CertRequestData,
  type CertState,
} from 'state/types/certTypes';

import { API } from 'util/constants';

const initialState: CertState = {
  certificate: undefined,
  request: undefined,
};

export default function reducer(
  state: CertState = initialState,
  action: Action
) {
  switch (action.type) {
    case GET_CERT_STATUS_SUCCESS:
      return {
        ...state,
        certificate: action.payload.certificate,
        request: action.payload.request,
      };
    default:
      return state;
  }
}

export function createCertRequest(
  adminSession: string,
  certRequest: CertRequestData
) {
  return {
    types: [
      CREATE_CERT_REQUEST,
      CREATE_CERT_REQUEST_SUCCESS,
      CREATE_CERT_REQUEST_FAIL,
    ],
    promise: (client: Client, getState: GetState) =>
      client.post(`${API}/certificate/create-request`, {
        params: { session: adminSession },
        data: certRequest,
      }),
  };
}

export function deleteCertRequest(adminSession: string) {
  return {
    types: [
      DELETE_CERT_REQUEST,
      DELETE_CERT_REQUEST_SUCCESS,
      DELETE_CERT_REQUEST_FAIL,
    ],
    promise: (client: Client, getState: GetState) =>
      client.post(`${API}/certificate/request/_delete`, {
        params: { session: adminSession },
      }),
  };
}

export function getCertStatus(adminSession: string) {
  return {
    types: [GET_CERT_STATUS, GET_CERT_STATUS_SUCCESS, GET_CERT_STATUS_FAIL],
    promise: (client: Client, getState: GetState) =>
      client.get(`${API}/certificate/status`, {
        params: { session: adminSession },
      }),
  };
}

export function uploadCert(adminSession: string, formData: FormData) {
  return {
    types: [IMPORT_CERT, IMPORT_CERT_SUCCESS, IMPORT_CERT_FAIL],
    promise: (client: Client, getState: GetState) =>
      client.post(`${API}/certificate/import`, {
        params: { session: adminSession },
        formData: formData,
      }),
  };
}



// WEBPACK FOOTER //
// ./src/state/reducers/certReducer.js